export default function getProductTypesFromBrands(brands) {
    let productTypes = [];
    for (let i = 0, il = brands.length; i < il; ++i) {
        const brand = brands[i];
        // console.log('brand.productType', brand.productType);
        for (let i = 0, il = brand.productType.length; i < il; ++i) {
            const ptype = brand.productType[i];
            if (typeof productTypes[ptype.id] === 'undefined') {
                productTypes[ptype.id] = {};
            }

            productTypes[ptype.id].type = ptype;
            if (typeof productTypes[ptype.id].brands === 'undefined') {
                productTypes[ptype.id].brands = {};
            }
            productTypes[ptype.id].brands[brand.id] = brand;
        }
    }

    return Object.values(productTypes);
}
